export const valoresExibidosOffCanvasContratos: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',
  separadorItens: '',

  //Específicos
  produtoDAF: 'Produto Farmacêutico',
  contrato: 'Contrato',
  nObjeto: 'Nº Objeto',
  parcela: 'Parcela',
  nParcela: 'Nº Parcela',
  fatorEmbalagem: 'Fator Embalagem',
  valorUnitario: 'Valor Unitário (R$)',
  valorParcela: 'Valor Parcela (R$)',
  valorTotal: 'Valor Total (R$)',
  qtdTotal: 'Qtd Total',
  dataPrevista: 'Data de Entrega Prevista',
};

export const headersParcelasContratos = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Nº Objeto', width: 10, key: 'parcelaObjetoNumero' },
  { text: 'Nº Parcela', width: 10, key: 'parcelaNumero' },
  { text: 'Data Prevista', width: 12, key: 'parcelaDataPrevista' },
  { text: 'Produto Farmacêutico', width: 45, key: 'parcelaProdutoDaf' },
  { text: 'Qtd Total', width: 10, key: 'parcelaQtdTotal' },
  { text: 'Valor Parcela R$', width: 10, key: 'parcelaValorParcela' },
];

export const fieldObjectParcelaContrato = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
